'use client';

import { cn } from '@/shared/utils/cn';
import React, { ReactNode } from 'react';
import { Button } from '@/shared/components/primitives/button';

type Variant = 'primary' | 'secondary' | 'noStyle' | 'disabled' | 'purchase' | 'purchaseToken';

type ActionButtonWithDescriptionProps = {
  title: ReactNode;
  description?: ReactNode;
  isLoading?: boolean;
  variant?: Variant;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
};

export const ActionButtonWithDescription = ({
  title,
  description,
  isLoading = false,
  variant = 'primary',
  onClick,
  className = '',
  disabled = false,
}: ActionButtonWithDescriptionProps) => {
  return (
    <div
      className={cn(
        description && 'bg-background-panel flex items-center border-r-4 border-transparent',
        className,
      )}
    >
      <Button
        className='min-w-36 self-stretch'
        type='button'
        onClick={onClick}
        disabled={isLoading || disabled}
        aria-disabled={isLoading || disabled}
        aria-busy={isLoading}
        variant={variant}
      >
        {title}
      </Button>
      {description && <span className='px-4 py-1'>{description}</span>}
    </div>
  );
};
